import axiosInstance from "api/axiosInstance";

import type { Review, ProductType, ReviewListParams } from "api/types/reviews.types";

const BASE = "/server/buccl_main/api/v1";

export const reviewsService = {
  list: (productType: ProductType, productId: number, params?: ReviewListParams) => axiosInstance.get<Review[]>(`${BASE}/${productType}/${productId}/reviews/`, { params }),

  get: (reviewId: number) => axiosInstance.get<Review>(`${BASE}/reviews/${reviewId}/`),

  update: (reviewId: number, payload: { rating?: number; content?: string }) => axiosInstance.put<Review>(`${BASE}/reviews/${reviewId}/`, payload),

  remove: (reviewId: number) => axiosInstance.delete(`${BASE}/reviews/${reviewId}/`),

  myReviews: () => axiosInstance.get<Review[]>(`${BASE}/reviews/my/`),

  // 어드민 전용
  adminList: (params?: ReviewListParams) => axiosInstance.get<Review[]>(`${BASE}/admin/reviews/`, { params }),

  toggleBlind: (reviewId: number, isBlind: boolean) => axiosInstance.patch<Review>(`${BASE}/admin/reviews/${reviewId}/blind/`, { is_blind: isBlind }),
};
